<template>
  <section id="spotproduktion" class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.production.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">{{ t('landing.production.body') }}</p>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          v-for="tier in TIERS"
          :key="tier"
          class="p-6 rounded-2xl bg-neutral-800 text-left flex flex-col gap-2"
        >
          <span class="text-xs text-neutral-400 uppercase tracking-wide">
            {{ t(`landing.production.${tier}.name`) }}
          </span>
          <span class="text-2xl font-extrabold">{{ t(`landing.production.${tier}.price`) }}</span>
          <p class="text-neutral-300 mt-0 mb-0">{{ t(`landing.production.${tier}.includes`) }}</p>
        </div>
      </div>

      <div class="flex flex-row flex-wrap justify-center items-center gap-2 mt-6 text-neutral-300">
        <template v-for="(step, index) in FLOW" :key="step">
          <VaIcon v-if="index" name="arrow_forward" size="16px" />
          <span>{{ t(`landing.production.${step}`) }}</span>
        </template>
      </div>

      <div class="mt-6">
        <VaButton size="large" href="mailto:hello@mysoundz.ch?subject=Spotproduktion%20In-Store">
          {{ t('landing.production.submit') }}
        </VaButton>
      </div>

      <p class="text-sm text-neutral-300 mt-4">{{ t('landing.production.extras') }}</p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaButton, VaIcon } from 'vuestic-ui'

const { t } = useI18n()

const TIERS = ['voice', 'vibe', 'story'] as const
const FLOW = ['flowSubmit', 'flowListen', 'flowApprove', 'flowLive'] as const
</script>
